import {Role} from '.'

export const ROLE_NAME: Record<Role, string> = {
  root: 'Root',
  director: 'Director',
  coordinator: 'Loans Coordinator',
  controller: 'Financial Controller',
  manager: 'Lending Manager',
  'associated-manager': 'Assistant Lending Manager',
  user: 'User',
  broker: 'Broker',
}
